import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import React from 'react';
import Nabour from '../Nabour';
import Styles from './styles.js';
const Neighbourhood = ({
  title,
  subTitle,
  space,
  img1,
  img2,
  img3,
  cardTitle,
  cardSubTitle,
  details,
  cardTitle2,
  cardSubTitle2,
  details2,
  cardTitle3,
  cardSubTitle3,
  details3,
  heading,
  bgcolor,
}) => {
  return (
    <>
      <div
        className={space ? 'w-full pt-5' : 'w-full pt-4'}
        style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
        {heading ? (
          <div className=" " style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
            <HeadingSection title={heading} bgcolor={bgcolor} />
          </div>
        ) : null}
        <div className="lg:container px-6 lg:px-0 mx-auto">
          <div className="flex justify-center 2xl:px-3">
            <div className="col-12">
              <div className="flex justify-center">
                <div className="">
                  <div className="text-center mb-10">
                    <h6
                      className="font-normal  text-[36px] leading-[45px]"
                      style={{
                        fontFamily: 'josefin Sans',                        color: '#fdbd00',
                      }}>
                      {title}
                    </h6>
                    <p className="fs-14-16 py-2" style={{ fontFamily: 'josefin Sans', color: '#a9a9a9' }}>
                      {subTitle}
                    </p>
                  </div>
                </div>
              </div>
              <div className={space ? 'grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-12  md:mt-6 mt-2' : 'grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-12  md:mt-12 mt-3'}>
                <div className=" px-mobile-nabourhood">
                  <Nabour title1={cardTitle} title2={cardSubTitle} details={details} imgsrc={img1} />
                </div>
                <div className=" px-mobile-nabourhood">
                  <Nabour title1={cardTitle2} title2={cardSubTitle2} details={details2} imgsrc={img2} />
                </div>
                <div className=" px-mobile-nabourhood">
                  <Nabour title1={cardTitle3} title2={cardSubTitle3} details={details3} imgsrc={img3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default Neighbourhood;
